import { Link } from "react-router-dom";
import { Landmark, Home as HomeIcon, Wallet, FileCheck, Users, ShieldCheck, ArrowRight, Lock } from "lucide-react";

const services = [
  { icon: Wallet, title: "Finanziamenti", desc: "Ti affianchiamo nella preparazione della documentazione per la richiesta di un finanziamento." },
  { icon: HomeIcon, title: "Mutui", desc: "Supporto nella raccolta dei documenti necessari per la valutazione del mutuo." },
  { icon: Landmark, title: "Cessione del quinto", desc: "Assistenza per organizzare la pratica di cessione del quinto dello stipendio o della pensione." },
];

const steps = [
  { icon: FileCheck, title: "Raccolta documenti", desc: "Raccogliamo insieme a te tutta la documentazione necessaria." },
  { icon: ShieldCheck, title: "Verifica", desc: "Verifichiamo che la pratica sia completa e corretta." },
  { icon: Users, title: "Reparto competente", desc: "Passiamo la richiesta al reparto competente che la valuterà." },
];

export default function Credito() {
  return (
    <div data-testid="credito-page">
      <section className="bg-[#0A192F] py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-[0.15em] text-[#10B981]">
            <Lock className="h-3.5 w-3.5" /> Riservato agli abbonati
          </span>
          <h1 className="mt-5 max-w-3xl font-display text-4xl font-extrabold tracking-tighter text-white sm:text-5xl">
            Supporto credito per i clienti ViviTranquillo
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-slate-300">
            Ti aiutiamo nella raccolta e verifica della documentazione e inoltriamo la richiesta
            al reparto competente per la valutazione. Un servizio riservato agli abbonati.
          </p>
          <Link to="/piano" data-testid="credito-piano-btn" className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#10B981] px-7 py-3 font-semibold text-white transition-colors hover:bg-[#059669]">
            Attiva il Piano €49/anno <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>

      <section className="bg-white py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="font-display text-3xl font-bold text-[#0A192F]">Di cosa ci occupiamo</h2>
          <div className="mt-10 grid gap-6 lg:grid-cols-3">
            {services.map((s) => (
              <div key={s.title} data-testid={`credito-service-${s.title.toLowerCase().replace(/[^a-z]/g, "")}`} className="flex flex-col items-start gap-4 rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#0A192F]/5">
                  <s.icon className="h-6 w-6 text-[#0A192F]" />
                </span>
                <h3 className="font-display text-xl font-bold text-[#0A192F]">{s.title}</h3>
                <p className="text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#F8FAFC] py-16 lg:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <h2 className="font-display text-3xl font-bold text-[#0A192F]">Come funziona</h2>
          <div className="mt-10 grid gap-6 lg:grid-cols-3">
            {steps.map((s, i) => (
              <div key={s.title} className="rounded-2xl border border-slate-200 bg-white p-8">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[#10B981] font-display text-base font-bold text-white">{i + 1}</span>
                <s.icon className="mt-5 h-6 w-6 text-[#10B981]" />
                <h3 className="mt-3 font-display text-lg font-bold text-[#0A192F]">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="mt-10 rounded-2xl border border-[#F97316]/30 bg-[#F97316]/5 p-6">
            <p className="text-sm leading-relaxed text-slate-700">
              <strong className="text-[#0A192F]">Trasparenza:</strong> ViviTranquillo offre esclusivamente un
              servizio di supporto documentale e di indirizzamento al reparto competente. La valutazione e la
              decisione finale spettano sempre agli enti preposti.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
